"use strict";

exports.__esModule = true;
exports.Strip = void 0;

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Strip =
/*#__PURE__*/
function () {
  function Strip(config) {
    this.ratio = 0;
    this.groups = [];
    this.width = 0;
    this.height = 0;
    this.isFullWidth = true;
    this.idx = config.idx;
    this.groupsPerStrip = config.groupsPerStrip;
    this.oneRow = config.oneRow;
    this.gallerySize = config.gallerySize;
    this.container = config.container;
  }

  var _proto = Strip.prototype;

  _proto.addGroup = function addGroup(group) {
    if (this.hasGroups) {
      this.lastGroup.isLastGroup = false;
    }

    this.groups.push(group);
    group.stripIdx = this.idx;
    this.lastGroup.isLastGroup = true;
    this.lastGroup.stripWidth = this.height * this.ratio;
  };

  _proto.markAsIncomplete = function markAsIncomplete() {
    //prevent from the last group to be streched
    this.isFullWidth = false;
    this.lastGroup.isLastGroup = false;
  };

  _proto.setWidth = function setWidth(width) {
    this.width = width;

    if (this.hasGroups) {
      this.lastGroup.stripWidth = width;
    }
  };

  _proto.resizeToHeight = function resizeToHeight(height) {
    this.height = height;
    var left = 0;
    var remainder = 0;

    for (var _iterator = this.groups, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var group = _ref;
      group.setLeft(left); // group.left = (left);

      group.width += remainder; //add the remainder from the last group round

      group.resizeToHeight(height);
      remainder = group.width;
      group.round();
      remainder -= group.width;
      left += group.width;
    }
  };

  _proto.isFull = function isFull(newGroup, isLastImage) {
    if (!this.hasGroups) {
      return false;
    }

    var groupsPerStrip = this.groupsPerStrip,
        oneRow = this.oneRow,
        gallerySize = this.gallerySize;

    if (groupsPerStrip > 0) {
      return this.groups.length >= groupsPerStrip;
    }

    var galleryWidth = this.container.galleryWidth;
    var isStripSmallEnough;

    if (oneRow) {
      isStripSmallEnough = false; //onerow layout is one long strip
    } else {
      var withNewGroup = galleryWidth / (this.ratio + newGroup.ratio) - gallerySize; //start a new strip BEFORE adding the current group

      var withoutNewGroup = galleryWidth / this.ratio - gallerySize; //start a new strip AFTER adding the current group

      if (isNaN(withNewGroup) || isNaN(withoutNewGroup)) {
        isStripSmallEnough = false;
      } else if (withoutNewGroup < 0) {
        //the strip is already too small
        isStripSmallEnough = true;
      } else if (withNewGroup < 0) {
        //adding the new group makes is small enough
        // check if adding the new group makes the strip TOO small
        //so - without the new group, the strip is larger than the required size - but adding the new group might make it too small
        isStripSmallEnough = Math.abs(withoutNewGroup) < Math.abs(withNewGroup);
      } else {
        isStripSmallEnough = false;
      }

      if (isStripSmallEnough && isLastImage) {
        //if it is the last image - prefer adding it to the last strip rather putting it on a new strip
        isStripSmallEnough = Number(Math.abs(withoutNewGroup)) < Math.abs(withNewGroup);
      }
    }

    return isStripSmallEnough;
  };

  _createClass(Strip, [{
    key: "hasGroups",
    get: function get() {
      return this.groups.length > 0;
    }
  }, {
    key: "lastGroup",
    get: function get() {
      return this.groups[this.groups.length - 1];
    }
  }, {
    key: "scheme",
    get: function get() {
      return {
        idx: this.idx,
        groups: this.groups.map(function (group) {
          return group.scheme;
        }),
        width: this.width,
        height: this.height,
        ratio: this.ratio,
        isFullWidth: this.isFullWidth
      };
    }
  }]);

  return Strip;
}();

exports.Strip = Strip;